import { combineReducers } from "redux";
import cart from "../common/reducers/cart";
import userInfo from "../common/reducers/userInfo";
import userAddress from "../common/reducers/userAddress";
import productDefinitions from "../common/reducers/productDefinitions";

const rootReducer = combineReducers({
  cart,
  userInfo,
  userAddress,
  productDefinitions,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
